<template>
  <div>
    <div class="search-form">
      <div class="search-form-left">
        <div class="form">
          <a-form-model
            :model="form"
            layout="inline"
          >
            <a-form-model-item
              prop="baseId"
              label="基地:"
            >
              <a-select
                v-model="form.baseId"
                placeholder="请选择基地"
                allow-clear
                show-search
                :filter-option="filterOption"
                @inputKeydown="inputKeydown($event, checkResource)"
              >
                <a-select-option
                  v-for="item in baseOptions"
                  :key="item.baseId"
                >
                  {{ item.baseName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item
              label="年度："
              prop="year"
            >
              <a-date-picker
                v-model="form.year"
                mode="year"
                :open="isopen"
                placeholder="请选择年份"
                format="YYYY"
                style="width: 100%;"
                :allow-clear="true"
                @panelChange="panelChange"
                @openChange="openChangeOne"
              />
            </a-form-model-item>
          </a-form-model>
        </div>
        <div class="ant-btns-mrright">
          <TableActions
            :actions="headerActions"
            @checkResource="checkResource"
          />
        </div>
      </div>
      <div class="search-form-right">
        <TableActions
          :actions="rightActions"
          @exportResource="exportNotTaxIncome"
        />
      </div>
    </div>
    <div class="table">
      <a-table
        :data-source="dataSource"
        :loading="loading"
        :columns="columns"
        :pagination="pagination"
        :expanded-row-keys="openRowKeys"
        :row-key="(item, index) => item.baseId + ''+ item.year"
        :scroll="{ x: 1200 }"
        @expand="handleClickRow"
        @change="handleTableChange"
      >
        <a-table
          slot="expandedRowRender"
          slot-scope="record"
          :loading="loading2"
          :columns="innerColumns"
          :data-source="record.innerDataSource"
          :row-key="(item, index) => index"
          :pagination="false"
          :show-header="false"
        />
      </a-table>
    </div>

    <ExportTables
      :visible="exportVisible"
      :loading="confirmLoading"
      @cancel="handleCancel"
      @exportOk="exportOk"
      @monSelected="monSelected"
    />
  </div>
</template>

<script>
import {
  queryNotTaxIncome, querySubNotTaxIncome, exportNotTaxIncome
} from '@/api/summaryIncome.js'
import {
  queryAllProductTypes, queryBases
} from '@/api/common.js'
import ExportTables from '@/components/exportTables/exportTables.vue'
import { excelDown, filterOption, inputKeydown } from '@/utils/utils.js'
import { pagination } from '@/constants/tableSetting'
import moment from 'moment'

const innerColumns = [{
  title: '',
  dataIndex: '',
  key: '',
  width: '100px'
},
{
  title: '年度',
  dataIndex: 'yearMonth',
  key: 'yearMonth',
  width: '100px'
}
]

const headerActions = [
  {
    title: '查询',
    type: 'primary',
    action: 'checkResource'
  }
]

const rightActions = [
  {
    title: '导出',
    type: 'primary',
    ghost: true,
    action: 'exportResource',
    apis: ['@baseInfo/Export_Bases']
  }
]

export default {
  components: {
    ExportTables
  },
  data () {
    return {
      columns: [
        {
          title: '基地',
          dataIndex: 'baseName',
          key: 'baseName',
          width: '100px'
        },
        {
          title: '时间',
          dataIndex: 'year',
          key: 'year',
          width: '100px'
        },
        {
          title: '合计',
          dataIndex: 'totalAmount',
          key: 'totalAmount',
          width: '100px'
        }
      ],
      headerActions,
      form: {
        baseId: undefined,
        year: undefined
      },
      innerColumns,
      baseOptions: [],
      dataSource: [],
      dataSourceTempt: [],
      productTypesTempt: [],
      loading2: true,
      totalAmounts: [],
      loading: true,
      pagination: {
        ...pagination,
        pageSize: 100
      },
      isopen: false,
      exportVisible: false,
      confirmLoading: false,
      openRowKeys: [],
      rightActions,
      monthOptions: []
    }
  },
  mounted () {
    this.form.year = moment(new Date()).format('YYYY')
    this.fetchData()
    this.fetchSearchOptions()
  },
  methods: {
    excelDown,
    filterOption,
    inputKeydown,
    moment,
    checkResource () {
      this.pagination.current = 1
      this.fetchData()
    },
    async fetchData () {
      this.openRowKeys = []
      this.loading = true
      console.log(this.form.year)
      await queryNotTaxIncome({
        pageIndex: this.pagination.current,
        pageSize: 99,
        ...this.form
      }).then((data) => {
        this.pagination.total = data.totalRecords
        this.dataSourceTempt = data.data
        this.dataSource = data.data
        this.totalAmounts = data.totalAmounts
        const len = this.dataSourceTempt.length
        this.dataSourceTempt.map((dataSourceTemptItem, index) => {
          dataSourceTemptItem.productTypes.map((item) => {
            this.$set(this.dataSource[index],
              item.productTypeId,
              item.amount)
          })
        })
        if (len > 0) {
          this.dataSource.push({})
          this.$set(this.dataSource[len],
            'totalAmount',
            data.totalAmount)

          this.totalAmounts.map((item) => {
            this.$set(this.dataSource[len],
              'year',
              '总计')
            this.$set(this.dataSource[len],
              item.productTypeId,
              item.amount)
          })
        }
      })
      this.loading = false
    },
    async fetchSearchOptions () {
      this.loading = true
      this.innerColumns = [{
        title: '',
        dataIndex: '',
        key: '',
        width: '100px'
      },
      {
        title: '年度',
        dataIndex: 'yearMonth',
        key: 'yearMonth',
        width: '100px'
      },
      {
        title: '合计',
        dataIndex: 'totalAmount',
        key: 'totalAmount',
        width: '100px'
      }
      ]
      await queryAllProductTypes().then((data) => {
        this.productTypesTempt = data
        this.productTypesTempt.map((item) => {
          this.columns.push({
            title: item.productTypeName,
            dataIndex: item.productTypeId,
            key: item.productTypeId,
            width: '100px'
          })
          this.innerColumns.push({
            title: item.productTypeName,
            dataIndex: item.productTypeId,
            key: item.productTypeId,
            width: '100px'
          })
        })
      })
      await queryBases().then((data) => {
        this.baseOptions = data
      })
      await queryAllProductTypes().then((data) => {
        this.productTypetions = data
      })
      this.loading = false
    },
    handleTableChange (pagination, filters, sorter) {
      this.pagination = { ...this.pagination, ...pagination }
      this.fetchData()// 获取表格数据的接口
    },
    async handleClickRow (expanded, record) {
      if (expanded) {
        this.openRowKeys.push(record.baseId + '' + record.year)
        this.loading2 = true
        await querySubNotTaxIncome(
          {
            baseId: record.baseId,
            year: record.year
          }).then((data) => {
          record.innerDataSource = data
          this.dataSourceTempt = data
          // 将子记录的每条记录展开
          this.dataSourceTempt.map((item, index) => {
            item.productTypes.map((innerItem) => {
              this.$set(record.innerDataSource[index],
                innerItem.productTypeId,
                innerItem.amount)
            })
          })
        })
        this.loading2 = false
      } else {
        this.openRowKeys.pop(record.baseId + '' + record.year)
      }
    },
    openChangeOne (status) {
      this.isopen = !this.isopen
    },
    panelChange (value) {
      this.isopen = false
      this.form.year = value.format('YYYY')
    },
    monSelected (value) {
      this.monthOptions = value
    },
    async exportNotTaxIncome () {
      this.exportVisible = true
    },
    async exportOk (value) {
      await exportNotTaxIncome({
        ...this.form,
        subRecord: value,
        yearMonthStart: this.monthOptions[0],
        yearMonthEnd: this.monthOptions[1]
      }).then((data) => {
        this.excelDown(data, '未税收入')
        this.handleCancel()
      })
    },
    handleCancel () {
      this.exportVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-table-tbody tr:last-child td:first-child {
  visibility: hidden;
}
</style>
